import { Capacitor } from "@capacitor/core";
import {
  StripeConfigType,
  SubscriptionConfigType,
} from "@bitwarden/web-vault/app/models/types/environement-config.type";
import {
  StripeSubscriptionPaymentCycle,
  SubscriptionPaymentCycle,
} from "@bitwarden/web-vault/app/models/types/subscription.type";

const stripeConfig = process.env.STRIPE as unknown as StripeConfigType;
const subscriptionGeneralEndPoint = process.env.SUBSCRIPTION as unknown as SubscriptionConfigType;

type StripePriceConfig = Record<StripeSubscriptionPaymentCycle, string>;

export class StripeConfigData {
  private readonly __v = 1;

  private _url: string;
  private _redirectUrl: string;
  config: Record<string, any>;
  subscriptionConfig: Record<string, any>;

  constructor() {
    this.config = stripeConfig;
    this.subscriptionConfig = subscriptionGeneralEndPoint;
    this.url = `${stripeConfig.url}/${stripeConfig.apiStage}`;
    this._redirectUrl = stripeConfig.redirectUrl;
  }

  get stage(): string {
    return this.config.apiStage;
  }

  get price(): StripePriceConfig {
    return this.config.price;
  }

  get url(): string {
    return this._url;
  }

  set url(value: string) {
    this._url = value;
  }

  /**
   * Where Stripe sends the user back to after checkout. On the web that is the origin the app is
   * running on: the login lives in this tab's sessionStorage, so coming back on any other origin (a
   * local or preview server redirected to the configured site) lands on the login page. The native
   * shells serve from capacitor://localhost, which Stripe can't redirect to, so they keep the
   * configured URL.
   */
  get redirectUrl(): string {
    return Capacitor.isNativePlatform() ? this._redirectUrl : window.location.origin;
  }

  get paymentMethodTypes(): string[] {
    return this.config.payment_method_types;
  }
}
